/**
 * 工作报告 — 期间与周对齐相关工具（与后端自然周 / 历史月口径一致）
 */

/**
 * 与后端「自然周日起算」一致：某天所在周的周日 00:00（本地）
 * @param {Date|string|number} timeLike
 * @returns {Date}
 */
export function sundayStartOfDate (timeLike) {
  const t = timeLike instanceof Date ? timeLike : new Date(timeLike);
  const d = new Date(t.getFullYear(), t.getMonth(), t.getDate());
  const day = d.getDay();
  d.setDate(d.getDate() - day);
  d.setHours(0, 0, 0, 0);
  return d;
}

/**
 * 以周日为一周起点，将任意 yyyy-MM-dd 对齐为该周「周日～周六」
 * @param {string} yyyyMmDd
 * @returns {[string|null, string|null]}
 */
export function sundayToSaturdayRange (yyyyMmDd) {
  if (!yyyyMmDd) return [null, null];
  const parts = String(yyyyMmDd).slice(0, 10).split('-').map(Number);
  if (parts.length < 3 || parts.some(n => Number.isNaN(n))) return [null, null];
  const d = new Date(parts[0], parts[1] - 1, parts[2]);
  const day = d.getDay();
  const sun = new Date(d);
  sun.setDate(d.getDate() - day);
  const sat = new Date(sun);
  sat.setDate(sun.getDate() + 6);
  const fmt = (dt) => {
    const y = dt.getFullYear();
    const mo = String(dt.getMonth() + 1).padStart(2, '0');
    const da = String(dt.getDate()).padStart(2, '0');
    return `${y}-${mo}-${da}`;
  };
  return [fmt(sun), fmt(sat)];
}

/**
 * 本地 Date → yyyy-MM-dd
 * @param {Date} date
 * @returns {string}
 */
export function formatDateToYmd (date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * 月报「报告月份」：禁止选择当月及未来月（与后端月报仅历史完整自然月一致）
 * @returns {{ disabledDate: (time: Date) => boolean }}
 */
export function getMonthlyReportMonthPickerOptions () {
  return {
    disabledDate (time) {
      const now = new Date();
      const firstThis = new Date(now.getFullYear(), now.getMonth(), 1);
      return time.getTime() >= firstThis.getTime();
    }
  };
}

/**
 * 周报锚点日期：禁止选择本周及未来周（按周日对齐后与「本周」比较）
 * @returns {{ disabledDate: (time: Date) => boolean }}
 */
export function getWeeklyAnchorDatePickerOptions () {
  return {
    disabledDate (time) {
      const pickSun = sundayStartOfDate(time);
      const thisSun = sundayStartOfDate(new Date());
      return pickSun.getTime() >= thisSun.getTime();
    }
  };
}

/**
 * 提交前与后端时段约束对齐；不通过时返回中文说明，通过返回 null
 * @param {{ reportType: string, periodStart: string|null, periodRange: [string,string]|null, weekAnchorDate: string|null }} params
 * @returns {string|null}
 */
export function validateWorkReportPeriodHistorical ({
  reportType,
  periodStart,
  periodRange,
  weekAnchorDate
}) {
  if (reportType === 'monthly') {
    if (!periodStart) return '请选择报告月份';
    const parts = periodStart.split('-').map(Number);
    const mStart = new Date(parts[0], parts[1] - 1, 1);
    mStart.setHours(0, 0, 0, 0);
    const now = new Date();
    const firstThis = new Date(now.getFullYear(), now.getMonth(), 1);
    firstThis.setHours(0, 0, 0, 0);
    if (!(mStart < firstThis)) return '月报仅可选择当前月份之前的完整自然月';
  }
  if (reportType === 'weekly') {
    const ps =
      periodRange && periodRange[0]
        ? periodRange[0]
        : weekAnchorDate;
    if (!ps) return '请选择周报周内日期';
    const segs = String(ps).slice(0, 10).split('-').map(Number);
    const anchor = new Date(segs[0], segs[1] - 1, segs[2]);
    const pickSun = sundayStartOfDate(anchor);
    const thisSun = sundayStartOfDate(new Date());
    if (pickSun.getTime() >= thisSun.getTime()) {
      return '周报仅可选择当周之前的自然周（周日至周六）';
    }
  }
  return null;
}
